import { apiRequest } from "./axiosInstance";


export const getInventoryApi = async (params)=>{
    const response = await apiRequest({
        url: "/inventory/getInventory",
        method: "GET",
        params:params
      });
      return response?.data
}


export const createInventoryApi = async (id,body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/inventory/createInventory?companyId=${id}`,
      method: "POST",
      data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};
export const updateInventoryApi = async (body,id) => {
  const response = await apiRequest({
    url: `/inventory/${id}`,
    method: "PUT",
    data: body,
  });
  return response?.data;
};


